(() => {
  const membershipVariants = new Set(['58306376270198', '58306376335734']);
  const ticketVariants = new Set(['58306376401270', '58306376434038']);
  const root = window.Shopify?.routes?.root || '/';
  const route = (path) => `${root}${String(path).replace(/^\//, '')}`;
  const originalFetch = window.fetch.bind(window);

  const getVariantId = (form) => String(form?.querySelector('[name="id"]')?.value || '').trim();
  const getOther = (data) => String(
    data?.other ?? data?.ovrigt ?? data?.extra ?? data?.message ?? data?.note ??
    data?.comment ?? data?.comments ?? data?.special_request ?? data?.special_requests ??
    data?.tk?.other ?? data?.tk?.ovrigt ?? data?.tk?.extra ?? ''
  ).trim();
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : String(input?.url || '');
    const body = init?.body;
    const isCartAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
    let note = '';

    if (isCartAdd && body instanceof FormData) {
      note = String(body.get('properties[Övrigt]') || body.get('properties[Övrig information]') || '').trim();
    }

    const response = await originalFetch(input, init);

    if (response.ok && note) {
      try {
        await originalFetch(route('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            note,
            attributes: {
              'Övrigt': note,
              'KUF – Övrigt': note
            }
          })
        });
      } catch (error) {
        console.error('KUF: kunde inte spara meddelandet som orderanteckning.', error);
      }
    }

    return response;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target?.closest?.('form');
    if (!form) return;

    const variantId = getVariantId(form);
    const isApprovedKufForm = form.matches('[data-kuf-ticket-form]') || Boolean(form.closest('[data-kuf-payment-root]'));
    if (isApprovedKufForm) return;

    if (membershipVariants.has(variantId) || ticketVariants.has(variantId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(route(membershipVariants.has(variantId) ? 'pages/membership' : 'pages/eventanmalan'));
    }
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement && event.target.matches('[data-kuf-ticket-form]') ? event.target : null;
    if (!form || event.defaultPrevented || form.dataset.asyncSubmitting === 'true') return;

    event.preventDefault();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const button = form.querySelector('[data-ticket-submit]');
    const errorBox = form.querySelector('[data-ticket-error]');
    form.dataset.asyncSubmitting = 'true';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Öppnar betalningen…';
    }
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    try {
      const payload = new FormData(form);
      payload.delete('return_to');
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Biljetten kunde inte läggas till. Försök igen.');
      }
      window.location.assign(route('checkout'));
    } catch (error) {
      delete form.dataset.asyncSubmitting;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Betala';
      }
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = error.message || 'Ett tekniskt fel uppstod. Försök igen.';
      }
    }
  });

  const replaceOutdatedOffer = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (/Bli medlem och spara 71\s*% på kickoffen/i.test(node.nodeValue || '')) {
        node.nodeValue = node.nodeValue.replace(/Bli medlem och spara 71\s*% på kickoffen/i, 'Medlemskap + kickoff för 379 kr – spara upp till 31 %');
      }
    });
    document.querySelectorAll('.kuf-package__saving').forEach((element) => {
      element.textContent = 'Spara upp till 31 %';
    });
  };

  const initManagementMessages = () => {
    const source = document.getElementById('kufManagementSnapshotData');
    const tabs = document.querySelector('.kufm__tabs');
    const ticketsPanel = document.getElementById('tickets');
    if (!source || !tabs || !ticketsPanel) return;

    let snapshot;
    try {
      snapshot = JSON.parse(source.textContent || '{}');
    } catch (error) {
      console.error('KUF Management: kunde inte läsa meddelandedata.', error);
      return;
    }

    const orders = Array.isArray(snapshot?.o) ? snapshot.o : (Array.isArray(snapshot?.orders) ? snapshot.orders : []);
    const records = orders.map((order) => ({
      order,
      number: order.no || order.name || order.order_number || '—',
      customer: order.n || order.cname || order.customer_name || '—',
      email: order.e || order.email || '—',
      date: order.d || order.created_at || '',
      message: getOther(order)
    }));
    const messages = records.filter((record) => record.message);

    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.tab = 'messages';
    button.textContent = `Meddelanden${messages.length ? ` (${messages.length})` : ''}`;
    tabs.appendChild(button);

    const panel = document.createElement('div');
    panel.id = 'messages';
    panel.className = 'kufm__panel';
    panel.innerHTML = messages.length ? `
      <div class="kufm__table-wrap"><table><thead><tr><th>Order</th><th>Kund</th><th>E-post</th><th>Datum</th><th>Övrigt / meddelande</th></tr></thead><tbody>
      ${messages.map((record) => `<tr data-search="${escapeHtml(`${record.number} ${record.customer} ${record.email} ${record.message}`)}"><td><strong>${escapeHtml(record.number)}</strong></td><td>${escapeHtml(record.customer)}</td><td>${escapeHtml(record.email)}</td><td>${escapeHtml(record.date || '—')}</td><td class="kufm__message">${escapeHtml(record.message)}</td></tr>`).join('')}
      </tbody></table></div>` : '<div class="kufm__empty">Inga meddelanden har lämnats ännu.</div>';
    ticketsPanel.insertAdjacentElement('afterend', panel);

    const cards = document.querySelector('.kufm__cards');
    if (cards) {
      const card = document.createElement('div');
      card.className = 'kufm__card';
      card.innerHTML = `<small>Meddelanden</small><strong>${messages.length}</strong>`;
      cards.appendChild(card);
    }

    document.querySelectorAll('.kufm__tabs button:not([data-tab="messages"])').forEach((existingButton) => {
      existingButton.addEventListener('click', () => panel.classList.remove('is-active'));
    });
    button.addEventListener('click', () => {
      document.querySelectorAll('.kufm__tabs button').forEach((tabButton) => tabButton.classList.toggle('is-active', tabButton === button));
      document.querySelectorAll('.kufm__panel').forEach((tabPanel) => tabPanel.classList.toggle('is-active', tabPanel === panel));
      document.getElementById('kufmSearch')?.dispatchEvent(new Event('input'));
    });

    const ordersTable = document.querySelector('#orders table');
    if (ordersTable) {
      const headingRow = ordersTable.querySelector('thead tr');
      if (headingRow) headingRow.insertAdjacentHTML('beforeend', '<th>Övrigt</th>');
      ordersTable.querySelectorAll('tbody tr[data-search]').forEach((row) => {
        const number = row.querySelector('td:first-child')?.textContent?.trim() || '';
        const record = records.find((item) => item.number === number);
        const message = record?.message || '';
        row.dataset.search = `${row.dataset.search || ''} ${message}`;
        row.insertAdjacentHTML('beforeend', `<td class="kufm__message ${message ? '' : 'kufm__message--empty'}">${message ? escapeHtml(message) : '—'}</td>`);
      });
    }
  };

  const start = () => {
    replaceOutdatedOffer();
    initManagementMessages();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
